import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { ListContainer } from './styled'
import { getBGCompanyRequest } from 'ducks/bgCompanyRequest'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { 
  bgCompanyRequestEditPath, 
  bgCompanyRequestDetailPath, 
  bgCompanyRequestCreatePath 
} from 'routes'
import { 
  MainBodyContent, 
  CustomButton, 
  SearchList,
  TablePagination 
} from 'components'
import {
  columnBgCompanyRequest,
  search_statusOption
} from './AttributeData'

const BGCompanyRequest = (props) => {
  const { 
    bgCompanyRequestLists, 
    valueForm, 
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getBGCompanyRequest({ page: 1, size: pageSize })
    props.getVendors()
    props.getCompanies()
    props.getCustomers()
  }, [])

  return (
    <MainBodyContent 
      headerTitle='Bank Guarantee Request New / Extend'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(bgCompanyRequestCreatePath) }
            icon='plus'
            btnColor='gray'
            title='Create' />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title' 
            fetchAPI={props.getBGCompanyRequest} 
            formSearchName='formSearchBGCompanyRequest' 
            filterStatus
            filterCompany
            filterVendor
            filterCustomer
            hideProject
            pageSize={pageSize} 
            filterStatusOptions={search_statusOption}
          />
          <ListContainer>
            <ReactTable
              data={bgCompanyRequestLists.data ? bgCompanyRequestLists.data : []}
              columns={columnBgCompanyRequest()}
              defaultPageSize={userPageSize}
              noDataText='No bank guarantee request data.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={bgCompanyRequestLists.totalPage ? bgCompanyRequestLists.totalPage : 0}
              currentPage={bgCompanyRequestLists.page ? bgCompanyRequestLists.page : 0}
              onPageChange={(pageIndex) => {
                props.getBGCompanyRequest({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getBGCompanyRequest({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 500].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(bgCompanyRequestEditPath(rowInfo.original.id), '_blank')
                      } else {
                        window.open(bgCompanyRequestDetailPath(rowInfo.original.id), '_blank')
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </ListContainer>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formSearchBGCompanyRequest')(state),
    bgCompanyRequestLists: state.bgCompanyRequest.lists.data,
  })
}

const mapDispatchToProps = {
  getBGCompanyRequest,
  getVendors, 
  getCompanies,
  getCustomers
}

const BankGuaranteeRequestForm = reduxForm({
  form: 'formSearchBGCompanyRequest',
  enableReinitialize: true,
})(BGCompanyRequest)

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeRequestForm)